var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-layout",class:{
    'is-vertical': _vm.direction === 'vertical',
    'is-horizontal': _vm.direction === 'horizontal'
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }